export const switchArrows = {
  name: "switch-arrows" as const,
  svg: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path fill-rule="evenodd" d="M16.864 2.364a.9.9 0 0 1 1.272 0l4 4a.9.9 0 0 1 0 1.272l-4 4a.9.9 0 0 1-1.272-1.272L19.327 7.9H9a.9.9 0 0 1 0-1.8h10.327l-2.463-2.464a.9.9 0 0 1 0-1.272Zm-9.728 10a.9.9 0 0 1 0 1.272L4.673 16.1H15a.9.9 0 1 1 0 1.8H4.673l2.463 2.464a.9.9 0 0 1-1.272 1.272l-4-4a.9.9 0 0 1 0-1.272l4-4a.9.9 0 0 1 1.272 0Z" clip-rule="evenodd"/></svg>`,
  keywords: ["switch-arrows"],
  category: "action" as const,
};
